// MODIFIED: Refactored nested itinerary view to use CreateTableNew
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ListIcon from "@mui/icons-material/List";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import { ImageViewModal } from "../../../../../common/Modal";
import { StatusBadge } from "../../../../../common/Badge";
import { formatDate, formatDateTimeShort, formatTime } from "../../../../../utils/textUtils";

const DTRCorrectionHistory = ({ isOpen, onClose, data = [] }) => {
  const [currentPage, setCurrentPage] = useState(1);
  // // ADDED: Dedicated pagination state for the nested itinerary table
  const [itineraryPage, setItineraryPage] = useState(1);

  const [viewer, setViewer] = useState({ isOpen: false, data: null });
  const [itineraryViewer, setItineraryViewer] = useState({ isOpen: false, list: [] });

  if (!isOpen) return null;

  // Configuration for Main History Table
  const headers = ["Ref No.", "Correction Date", "Type", "Time Requested", "Status", "Itinerary", "File"];
  const accessors = ["referenceNumber", "date", "timeType", "timeRendered", "status", "changeLogItineraries", "content"];

  // Configuration for Nested Itinerary Table
  const itinHeaders = ["Time In", "Time Out", "Location"];
  const itinAccessors = ["timeIn", "timeOut", "location"];

  const customRender = (row, accessor) => {
    if (accessor === "referenceNumber") return `CH-${row[accessor]?.toString().padStart(6, "0")}`;
    if (accessor === "date") return formatDate(row[accessor]);
    if (accessor === "timeRendered") return formatTime(row[accessor]);
    if (accessor === "status") return <StatusBadge status={row[accessor]} />;

    if (accessor === "changeLogItineraries") {
      return (
        <button
          onClick={() => {
            setItineraryViewer({ isOpen: true, list: row.changeLogItineraries || [] });
            setItineraryPage(1); // // Reset sub-table page on open
          }}
          className="text-blue-500 bg-transparent border-none cursor-pointer hover:text-blue-700"
        >
          <ListIcon fontSize="small" />
        </button>
      );
    }

    if (accessor === "content") {
      return row[accessor] ? (
        <button onClick={() => setViewer({ isOpen: true, data: row.content })} className="text-gray-500 bg-transparent border-none cursor-pointer">
          <AttachFileIcon fontSize="small" />
        </button>
      ) : "-";
    }
    return null;
  };

  // // ADDED: Custom renderer for the nested itinerary table
  const renderItineraryCell = (row, accessor) => {
    if (accessor === "timeIn" || accessor === "timeOut") {
      return formatDateTimeShort(row[accessor]);
    }
    return null;
  };

  return (
    <>
      <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3">
        <div className="bg-gray-50 w-full md:w-[95%] rounded-lg shadow-xl max-h-[90vh] flex flex-col">
          <div className="flex justify-between items-center px-6 py-3 border-b bg-white rounded-t-lg">
            <h2 className="text-xl font-semibold text-customMainColor">DTR Correction History</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-700 bg-transparent border-none cursor-pointer"><CloseIcon /></button>
          </div>
          <div className="p-6 overflow-y-auto">
            <CreateTable
              headers={headers}
              accessors={accessors}
              data={data}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              itemsPerPage={10}
              totalItems={data.length}
              customCellRenderer={customRender}
            />
          </div>
        </div>
      </div>

      <ImageViewModal isOpen={viewer.isOpen} onClose={() => setViewer({ ...viewer, isOpen: false })} fileData={viewer.data} fileType="image/jpeg" />

      {/* REFACTORED: Nested Itinerary Viewer Modal using CreateTableNew */}
      {itineraryViewer.isOpen && (
        <div className="fixed inset-0 z-[10001] bg-black/40 flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-3xl rounded-lg shadow-2xl flex flex-col max-h-[80vh]">
            <div className="p-4 border-b flex justify-between items-center bg-gray-50 rounded-t-lg">
              <h3 className="font-bold text-customMainColor">Itinerary Details</h3>
              <CloseIcon className="cursor-pointer text-gray-400 hover:text-gray-600" onClick={() => setItineraryViewer({ isOpen: false, list: [] })} />
            </div>
            <div className="p-6 overflow-y-auto">
              {/* // MODIFIED: Replaced manual table with CreateTable */}
              <CreateTable
                tableName="itinerary-history-table"
                headers={itinHeaders}
                accessors={itinAccessors}
                data={itineraryViewer.list}
                currentPage={itineraryPage}
                setCurrentPage={setItineraryPage}
                itemsPerPage={5}
                totalItems={itineraryViewer.list.length}
                customCellRenderer={renderItineraryCell}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DTRCorrectionHistory;